var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.002,
    height: 24.003,
    viewBox: "0 0 24.002 24.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Componente_207_9",
    "data-name": "Componente 207 \\u2013 9",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1851",
    "data-name": "Rect\\xE1ngulo 1851",
    width: 24,
    height: 24,
    transform: "translate(0.002)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "borrador",
    transform: "translate(-0.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_18",
    "data-name": "Sustracci\\xF3n 18",
    d: "M16890.369,23432h-9.615a2.126,2.126,0,0,1-1.494-.617l-5.516-5.518a2.11,2.11,0,0,1,0-2.986l.146-.148c.332-.33,1.084-1.082,2.074-2.074l7.061-7.064c2.5-2.5,4.652-4.656,4.973-4.973a2.1,2.1,0,0,1,2.982,0l5.516,5.516a2.116,2.116,0,0,1,0,2.986c-.145.143-2.631,2.631-5.514,5.514l-2.709,2.711-3.74,3.744c-.861.861-1.424,1.426-1.5,1.5h7.334a.706.706,0,0,1,0,1.412Zm-12.008-11.748-3.623,3.621a.707.707,0,0,0-.2.5.7.7,0,0,0,.2.5l5.516,5.516a.712.712,0,0,0,1,0l3.617-3.617Zm11.793-8.295a.58.58,0,0,0-.57.572.57.57,0,0,0,.168.406l2.439,2.439a.572.572,0,0,0,.807-.811l-2.436-2.436A.574.574,0,0,0,16890.154,23411.959Z",
    transform: "translate(-16872.998 -23408)",
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.8e2f24657b9ab993b3ba2c369d024a76.svg";
export { ForwardRef as ReactComponent };